<template>
  <div>
    <div class="lock-route" v-if="!shouldUserAccessRoute(route)">
      <div class="lock-indicator">
        <div class="block">
          <svg
            style="width: 30px; height: 30px"
            id="bold"
            enable-background="new 0 0 24 24"
            height="512"
            viewBox="0 0 24 24"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m18.75 9h-.75v-3c0-3.309-2.691-6-6-6s-6 2.691-6 6v3h-.75c-1.24 0-2.25 1.009-2.25 2.25v10.5c0 1.241 1.01 2.25 2.25 2.25h13.5c1.24 0 2.25-1.009 2.25-2.25v-10.5c0-1.241-1.01-2.25-2.25-2.25zm-10.75-3c0-2.206 1.794-4 4-4s4 1.794 4 4v3h-8zm5 10.722v2.278c0 .552-.447 1-1 1s-1-.448-1-1v-2.278c-.595-.347-1-.985-1-1.722 0-1.103.897-2 2-2s2 .897 2 2c0 .737-.405 1.375-1 1.722z"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="flex justify-between px-4 cursor-pointer">
      <div class="flex">
        <div>
          <div class="text-sm font-bold text-dark-type-3">
            {{ route.departure_time }}{{ route.time_of_day }}
          </div>
          <div class="font-medium text-xxs text-dark-type-4">
            {{ route["origin_bus_stop"]['busStopName'] }}
          </div>
        </div>
        <div class="ml-6">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12">
            <g fill="none" fill-rule="evenodd" transform="translate(-2 -4)">
              <circle cx="10" cy="10" r="10" fill="none" />
              <path
                d="M3.333 10H15m-4.167-4.167L15 10l-4.167 4.166"
                stroke="#737D78"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </g>
          </svg>
        </div>
        <div class="ml-6">
          <div class="text-sm font-bold text-dark-type-3">
            {{ arrivalTimeFormatted(route) }}
          </div>
          <div class="font-medium text-xxs text-dark-type-4">
            {{ route["destination_bus_stop"]['busStopName'] }}
          </div>
        </div>
      </div>
      <div class="flex">
        <div v-if="!isNewDRPEnabled">
          <div class="font-bold text-dark-type-3">&#8358; {{ route.fare }}</div>
        </div>
        <div class="ml-2">
          <label :for="route.route_id" class="inline-flex">
            <input
              type="radio"
              :checked="selectedRouteId === route.route_id"
              :id="route.route_id"
              :value="route.route_id"
            />
          </label>
        </div>
      </div>
    </div>
    <div class="px-4 -mt-1">
      <span class="font-medium text-xxs text-dark-type-4">
        <font-awesome-icon
          v-if="route.is_future_route"
          icon="flag"
          :style="{ color: '#ffb500' }"
        />
        {{ route.route_name }}</span
      >
    </div>
    <div class="flex justify-between mt-4">
      <div class="flex px-4 py-2">
        <div class="flex">
          <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
              <circle cx="6" cy="6" r="6" fill="#131615" />
              <g fill="#FFF" fill-rule="nonzero">
                <path
                  d="M5.637 3.977a.735.735 0 00-1.038-1.038.735.735 0 001.038 1.038zm1.657 3.515h-1.26v-1.35c.512.422 1.323.79 2.017.792v-.792c-.608.008-1.323-.319-1.712-.748l-.513-.568a.821.821 0 00-.251-.185.813.813 0 00-.354-.085h-.01a.828.828 0 00-.826.827v2.109c0 .606.493 1.1 1.1 1.1h1.857l1.283 1.283.526-.526-1.857-1.857z"
                />
                <path
                  d="M4.019 7.858v-3.3h-.735v3.3c0 1.012.821 1.834 1.833 1.834h2.2v-.734h-2.2a1.1 1.1 0 01-1.1-1.1z"
                />
              </g>
            </g>
          </svg>
          <div class="ml-1 font-medium text-dark-type-3 text-xxs">
            {{ route.route_total_seats }} spaces available
            {{ route.route_total_seats === 0 ? "(bus filled up)" : "" }}
          </div>
        </div>
        <div class="hidden ml-6">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
            <g fill="none" fill-rule="evenodd">
              <circle cx="6" cy="6" r="6" fill="#131615" />
              <path
                fill="#FFF"
                fill-rule="nonzero"
                d="M8.86 8.603v-.429h.43v-2.23l-.354-2.487H4.64l-.353 2.487v2.23h.429v.43H3.258v-3.89h.214a.43.43 0 00.429-.429V3.43A.43.43 0 003.472 3h-.643v5.603H2.4v.429h7.318v-.429h-.857zM5.002 6.96a.429.429 0 11.858.002.429.429 0 01-.858-.002zm3.002 1.644h-2.43v-.429h2.43v.43zm.143-1.215a.429.429 0 110-.86.429.429 0 010 .861zM4.748 5.744l.264-1.858h3.552l.264 1.858h-4.08z"
              />
            </g>
          </svg>
          <div class="hidden ml-1 font-medium text-dark-type-3 text-xxs">
            3 bus stops in route
          </div>
        </div>
      </div>
      <div class="flex px-4 py-2 bg-gray-type-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <g fill="#131615">
            <path
              d="M1.64 7.217V5.249a.328.328 0 000-.656c-.905 0-1.64.736-1.64 1.64v.656c0 .542.442.984.984.984h.656a.328.328 0 000-.656zm12.466-2.624a.328.328 0 000 .656v1.968a.328.328 0 000 .656h.656a.986.986 0 00.984-.984v-.656c0-.904-.735-1.64-1.64-1.64zm-8.529 9.185a.328.328 0 00-.328.328H3.28a.328.328 0 00-.656 0v.656c0 .542.442.984.984.984h1.313a.986.986 0 00.984-.984v-.656a.328.328 0 00-.328-.328zm7.217 0a.328.328 0 00-.328.328h-1.969a.328.328 0 00-.656 0v.656c0 .542.442.984.984.984h1.313a.986.986 0 00.984-.984v-.656a.328.328 0 00-.328-.328z"
            />
            <path
              d="M12.794 0H2.952c-.904 0-1.64.736-1.64 1.64v11.154c0 .904.736 1.64 1.64 1.64h9.842c.904 0 1.64-.736 1.64-1.64V1.64c0-.904-.736-1.64-1.64-1.64zm-8.53 1.312h7.218a.985.985 0 010 1.968H4.265a.985.985 0 01-.985-.984c0-.542.442-.984.985-.984zm0 11.154a.986.986 0 01-.984-.985c0-.542.442-.984.985-.984.542 0 .984.442.984.984a.986.986 0 01-.984.985zm7.217 0a.986.986 0 01-.984-.985c0-.542.442-.984.984-.984.543 0 .985.442.985.984a.986.986 0 01-.985.985zm1.64-4.265c0 .543-.44.984-.983.984h-8.53a.985.985 0 01-.984-.984v-3.28c0-.543.442-.984.984-.984h8.53c.542 0 .984.441.984.984V8.2z"
            />
          </g>
        </svg>
        <div class="ml-1 font-bold text-right text-xxs text-dark-type-3">
          {{route.vehicle_type || 'Bus'}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import FeatureFlagService, {FEATURE_FLAGS} from "@/services/feature-flags";

export default {
  props: {
    route: Object,
    selectedRouteId: [String, Number]
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    isNewDRPEnabled() {
      return FeatureFlagService.isFlagEnabled(FEATURE_FLAGS.DRP_CLIENT);
    },
  },
  methods: {
    arrivalTimeFormatted({ route_duration, departure_time, time_of_day }) {
      let routeDuration = route_duration;
      let departureTime = departure_time;
      let timeOfDay = time_of_day;

      let durationParts = routeDuration.split(" ");

      let duration = parseInt(durationParts[0]);

      if (durationParts[1] === "hour") {
        duration = duration * 60;
      }

      return moment(`${departureTime} ${timeOfDay}`, "h:mm A")
        .add(duration, "m")
        .format("h:mm a");
    },
    shouldUserAccessRoute(route) {
      return (
        route.route_visibility === "public" ||
        (route.route_visibility === "private" &&
          route.corporate_id &&
          (this.user ? route.corporate_id === this.user.corporate_id : true))
      );
    },
  }
}
</script>
